import { Box, TableRow, TableCell, keyframes } from '@mui/material';

const shimmer = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

const ShimmerBar = ({ flex = 1 }) => (
  <Box
    sx={{
      flex,
      height: 14,
      borderRadius: '4px',
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)',
      backgroundSize: '800px 100%',
      animation: `${shimmer} 1.6s ease-in-out infinite`,
    }}
  />
);

const SkeletonRows = ({ rows }) => (
  <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#ffffff' }}>
    {Array.from({ length: rows }).map((_, i) => (
      <Box
        key={i}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 1.5, md: 2.5 },
          px: { xs: 1.5, md: 2.5 },
          py: 2.2,
          borderBottom: '1px solid #f5f5f5',
          bgcolor: '#ffffff',
        }}
      >
        <ShimmerBar flex={0.8} />
        <ShimmerBar flex={1.8} />
        <ShimmerBar flex={1} />
        <ShimmerBar flex={0.7} />
        <ShimmerBar flex={1.2} />
        <ShimmerBar flex={1.4} />
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            flexShrink: 0,
            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)',
            backgroundSize: '800px 100%',
            animation: `${shimmer} 1.6s ease-in-out infinite`,
          }}
        />
      </Box>
    ))}
  </Box>
);

/**
 * Skeleton para el body de una tabla.
 * Efecto shimmer horizontal (estilo Instagram/Facebook).
 * Fondo siempre blanco. Sin header (el header real queda estático).
 *
 * - Default (variant="table-row"): <TableRow><TableCell colSpan=99> para usar dentro de <TableBody>
 * - variant="box": <Box> puro para vistas mobile sin tabla HTML
 */
export default function TableBodySkeleton({ rows = 8, variant = 'table-row' }) {
  if (variant === 'box') {
    return <SkeletonRows rows={rows} />;
  }

  return (
    <TableRow>
      <TableCell colSpan={99} sx={{ p: 0, border: 'none' }}>
        <SkeletonRows rows={rows} />
      </TableCell>
    </TableRow>
  );
}
